import React, {useEffect} from 'react';
import withQuestionLogic from "../../../HOC/withQuestionLogic";

const NoAnswerQuestion = ({markNextAble}) => {

    useEffect(() => {
        markNextAble(true);
    }, []);

    return (
        <React.Fragment>
        </React.Fragment>
    );
};

export default withQuestionLogic(NoAnswerQuestion);
